import { createSelector } from '@reduxjs/toolkit';
import { effectiveUserCourses, studentGroups } from '~/shared/libs/course-learning/context';

export const getUsersPagination = (state) => {
  return state?.users?.usersPagination;
};

export const getRawUserWithCourses = (state) => state?.users?.userWithCourses;
export const getStudentCourseContext = (state) => state?.users?.studentCourseContext;
export const getUserWithCourses = createSelector(
  [getRawUserWithCourses, getStudentCourseContext],
  effectiveUserCourses,
);

export const getSelectedStudent = (state) => {
  return state?.users?.selectedStudent;
};

export const getSelectedStudentsGroup = (state) => {
  const user = getRawUserWithCourses(state);
  if (user?.role === 'STUDENT') {
    const context = getStudentCourseContext(state);
    if (context?.mode === 'group' && context.userId === String(user._id) && context.group &&
      studentGroups([context.group], String(user._id)).length) return context.group;
    return null;
  }
  return state?.users?.selectedStudentsGroup;
};

export const getZeroLessonStudent = (state) => {
  return state?.users?.zeroLessonStudent;
};

export const getCurrentUser = (state) => {
  return state?.users?.currentUser;
};

export const getStudents = (state) => {
  return state?.users?.students;
};

export const getIsUserProfile = (state) => {
  return state?.users?.isUserProfile;
};

export const getTeacher = (state) => {
  return state?.users?.teacher;
};

export const getSelectedNoLevelUsers = (state) => {
  return state?.users?.selectedNoLevelUsers;
};

export const getOnlineUsers = (state) => {
  return state?.users?.onlineUsers;
};
